import React, { useCallback } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import './PdpImageGallery.css';
import { DeviceSize, useWindowSize } from 'hooks/useWindowSize';
import { useDispatch } from 'react-redux';
import { openProductImageGalleryModal } from 'store/modal/actions';
import { MobileImageGallery } from 'components/PdpImageGallery/MobileImageGallery';
import { DesktopImageGallery } from 'components/PdpImageGallery/DesktopImageGallery';
import { useGalleryPhotos } from '../../features/pdp/hooks/useGalleryPhotos';
import DesktopImageGalleryThumbnailView from 'components/PdpImageGallery/DesktopImageGalleryThumbnailView';
import { useSplitTreatment } from '../../hooks/splits/useSplitTreatment';
import { SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL, SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL_COOKIE } from 'constants/split';
import { IMAGE_CAROUSEL_TEST_SKUS } from 'constants/pdp';
import { useProduct } from '../../features/pdp';

export const PdpImageGallery: React.FC = () => {
  const dispatch = useDispatch();
  const photos = useGalleryPhotos();
  const { product } = useProduct();

  const { deviceSize } = useWindowSize();
  const isMobile = deviceSize === DeviceSize.SMALL;

  const { treatmentStatus: imageCarouselTest } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL,
    SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL_COOKIE
  );
  const showImageCarouselTest = imageCarouselTest && IMAGE_CAROUSEL_TEST_SKUS.includes(product.sku);

  const handleImageClick = useCallback((src: string): void => {
    dispatch(openProductImageGalleryModal({ src, photos }));
  }, [dispatch, photos]);

  const desktopGallery = showImageCarouselTest
    ? <DesktopImageGalleryThumbnailView photos={photos} sku={product.sku}/>
    : <DesktopImageGallery photos={photos} onImageClick={handleImageClick}/>;

  return isMobile
    ? <MobileImageGallery photos={photos} onImageClick={handleImageClick} sku={product.sku}/>
    : desktopGallery;
};
